import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { from, Observable } from 'rxjs'
import { BlockDataService } from '../../block-services/block-data.service'
import { BuilderService } from '../../builder-services/builder.service'
import { HelpersService } from '../../helpers.service'
import { TemplatesApiService } from 'src/app/builder-services/api/templates.api.service'

@Injectable({
  providedIn: 'root'
})
export class WebsiteTemplatesService extends BlockDataService {
  private builderUrl = ''

  options = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
  }

  token: any

  constructor(
    private http: HttpClient,
    private helper: HelpersService,
    private builderService: BuilderService,
    private templatesApi: TemplatesApiService
  ) {
    super()
    this.builderUrl = this.helper.getBuilderUrl()
  }

  /**
   * Get all website templates from Supabase
   */
  getTemplates = (): Observable<any> => {
    return from(this.templatesApi.getWebsiteTemplates())
  }

  /**
   * Get a specific website template by ID
   * @param id - Template ID
   */
  getTemplate = (id: string): Observable<any> => {
    return from(this.templatesApi.getWebsiteTemplate(id))
  }

  /**
   * Create a new website template
   * @param templateName - Name of the template
   * @param templateImage - URL of the template preview image
   * @param allPages - All pages data
   * @param headerData - Static header configuration
   * @param footerData - Static footer configuration
   */
  insertTemplate = (
    templateName: string,
    templateImage: string,
    allPages: any,
    headerData?: any,
    footerData?: any
  ): Observable<any> => {
    const templateData = {
      template_name: templateName,
      template_image: templateImage,
      pages: allPages,
      statics: {
        header: headerData || {},
        footer: footerData || {}
      },
      created_at: new Date().toISOString()
    }

    return from(this.templatesApi.insertWebsiteTemplate(templateData))
  }

  /**
   * Update an existing website template
   * @param id - Template ID
   * @param templateName - Name of the template
   * @param templateImage - URL of the template preview image
   * @param allPages - All pages data
   * @param headerData - Static header configuration
   * @param footerData - Static footer configuration
   */
  updateTemplate = (
    id: any,
    templateName: string,
    templateImage: string,
    allPages: any,
    headerData?: any,
    footerData?: any
  ): Observable<any> => {
    const templateData = {
      template_name: templateName,
      template_image: templateImage,
      pages: allPages,
      statics: {
        header: headerData || {},
        footer: footerData || {}
      },
      updated_at: new Date().toISOString()
    }

    return from(this.templatesApi.updateWebsiteTemplate(id, templateData))
  }

  /**
   * Delete a website template
   * @param id - Template ID to delete
   */
  deleteTemplate = (id: string): Observable<any> => {
    return from(this.templatesApi.deleteWebsiteTemplate(id))
  }

  /**
   * Upload template image
   * @param file - Image file to upload
   * @param id - Project ID
   * @param type - File type
   * @param name - File name
   */
  public uploadFile(file: File, id: any, type: string, name: string): Observable<any> {
    const formData = new FormData()
    this.token = this.builderService.getToken()
    formData.append('file', file)
    formData.append('token', this.token)
    formData.append('projectId', id)
    formData.append('file_type', type)
    formData.append('file_name', name)
    formData.append('template', 'true')

    return this.http.post(this.builderUrl + 'receive-file', formData)
  }
}
